import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'

import OrderClass from './../../../../../../../js/classes/Order'
import ScrollClass from './../../../../../../../js/classes/Scroll'

const Actions = ({ refetch, setHideErrors, cart }) => {
    const handleNext = (e) => {
        e.preventDefault()

        setHideErrors(true)

        refetch(() => {
            const errorBlock = document.querySelector('.happy-cart__item-error-amount')

            if (errorBlock) {
                ScrollClass.scrollTo(errorBlock)
            } else {
                document.location = OrderClass.url
            }
        })

        return false
    }

    return <div className="happy-cart__actions">
        <a href="/shop/" className="button button_big button_flat happy-cart__actions-back">
            Продолжить покупки
        </a>

        { cart?.summary >= 1000 ?
        <a href={ OrderClass.url } onClick={ handleNext.bind(this) } className="button button_big button_green happy-cart__actions-next">
            Оформить заказ
        </a> : <div className="happy-cart__min-order-summary">
            Минимальная сумма заказа 1 000 ₽
        </div> }
    </div>
}

export default Actions